<script lang="ts">
  import { recommendation } from "../../stores/recommendation"

  import ExpertHeading from "./ExpertHeading.svelte"
  import Text from "../Common/Text.svelte"
  import Card from "../Common/Card.svelte"

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: expert = $recommendation.details?.expert
</script>

{#if expert}
  <Card class="expert-bio-card">
    <ExpertHeading />
    <Text class="expert-bio">
      {@html expert.bio}
    </Text>
  </Card>
{/if}